import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { CostCenter } from "../models/CostCenter";

export const getCostCenters = async ({
	id = null,
}: {
	id?: number | null;
} = {}): Promise<CostCenter[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "OnlyActives", value: false }];

	if (id) {
		parameters.push({ name: "Id", value: id });
	}

	const resp = await apiService.callV2("[MILL].[GetCostCenters]", parameters);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as CostCenter[];
	}
	throw new Error(resp.message || "Error fetching cost centers");
};

export const upsertCostCenter = async (
	costCenter: CostCenter,
): Promise<CostCenter> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Id", value: costCenter.Id },
		{ name: "Name", value: costCenter.Name },
		{ name: "Description", value: costCenter.Description },
		{ name: "Bud", value: costCenter.Bud },
		{ name: "DeptId", value: costCenter.DeptId },
		{ name: "EndUser", value: costCenter.EndUser },
		{ name: "Comments", value: costCenter.Comments },
		{ name: "Active", value: costCenter.Active },
	];

	const resp = await apiService.callV2("[MILL].[UpsertCostCenter]", parameters);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows[0]", null) as CostCenter;
	}
	throw new Error(resp.message || "Error saving cost center");
};

export const removeCostCenter = async (id: number): Promise<void> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "Id", value: id }];

	const resp = await apiService.callV2("[MILL].[RemoveCostCenter]", parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting cost center");
	}
};
